module.exports = __webpack_public_path__ + "media/images/flags/gw-8b5feec746871c0d2f3d23ad46a8d4ab.svg";